<template>
  <div style="width:100%;height:100%;">
    <div class="manage-header">
      <h3>管理员列表</h3>
      <div>
        <input type="text" placeholder="请输入搜索内容">
        <i class="el-icon-search"  title="删除"></i>
      </div>
    </div>
    <div class="auth">
      <div v-for="user in userList" :key="user.id" class="userBox Radius">
        <div class="user-img"></div>
        <span  class="user-iname">{{user.name}}</span>
        <p>{{user.class}}</p>
        <p>{{user.time}}</p>
        <p class="user-email">{{user.email}}</p>
        <div class="user-edit">
          <i class="el-icon-edit" title="编辑"></i>
          <i class="el-icon-delete"  title="删除"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'authManage',
  data () {
    return {
      userList: [
        { id: 1, name: '张小青1', rank: 1, class: '技术部', time: '2020/9/9', email: '123456789@dstair.com', img: '1' },
        { id: 2, name: '张小青2', rank: 2, class: '技术部', time: '2020/9/9', email: '123456789@dstair.com', img: '1' },
        { id: 3, name: '张小青3', rank: 3, class: '技术部', time: '2020/9/9', email: '123456789@dstair.com', img: '1' },
        { id: 4, name: '张小青4', rank: 4, class: '技术部', time: '2020/9/9', email: '123456789@dstair.com', img: '1' },
        { id: 5, name: '张小青5', rank: 5, class: '技术部', time: '2020/9/9', email: '123456789@dstair.com', img: '1' },
        { id: 6, name: '张小青6', rank: 6, class: '技术部', time: '2020/9/9', email: '123456789@dstair.com', img: '1' },
        { id: 7, name: '张小青7', rank: 7, class: '技术部', time: '2020/9/9', email: '123456789@dstair.com', img: '1' },
        { id: 7, name: '张小青7', rank: 7, class: '技术部', time: '2020/9/9', email: '123456789@dstair.com', img: '1' },
        { id: 9, name: '张小青8', rank: 8, class: '技术部', time: '2020/9/9', email: '123456789@dstair.com', img: '1' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.manage-header{
    width:calc(100% + 0.48rem);
    height:1.76rem;
    transform:translate(-0.24rem,-0.24rem);
    background:white;
    box-shadow:inset 8px 8px 8px 2px rgba(0,0,0,0.04);
    text-align:left;
    padding-top:0.4rem;
    padding-left:0.4rem;
    h3{
        margin-bottom:0.2rem;
    }
    div{
        width:4rem;
        height:0.4rem;
        border:1px solid #eee;
        border-radius:0.2rem;
        padding:0 0.2rem;
        line-height:0.4rem;
        display:flex;
        align-items:center;
        justify-content:space-between;
    }
}
.auth{
    width:100%;
    display:flex;
    flex-wrap:wrap;
    justify-content:space-between;
    padding-top:0.24rem;
}
.userBox{
    width:1.82rem;
    height:2.46rem;
    background:white;
    margin-bottom:0.24rem;
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    justify-content:center;
    padding-left:0.24rem;
    overflow:hidden;
    .user-img{
      width:0.5rem;
      height:0.5rem;
      border-radius:50%;
      border:1px solid red;
      margin-bottom:0.1rem;
    }
    .user-iname{
      font-size:0.16rem;
      font-weight:600;
      margin-right:0.1rem;
    }
    p{
      margin-top:0.05rem;
      font-size:0.12rem;
      transform:scale(0.8) translateX(-15%);
    }
    .user-email{
        color:#01A3FF;
    }
    .user-edit{
        align-self:flex-end;
        margin:0.2rem 0.2rem 0 0;
        i{
            margin:0 0.05rem;
        }
    }
}

</style>
